import { Drawer } from "components";
import { ConnectDattoAccount } from "./connect-datto-account";
import { useGetDattoAuthConfig } from "controller";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

interface DattoDrawerProps {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const DattoConnectionDrawer = ({
  open,
  onOpen,
  onClose,
}: DattoDrawerProps) => {
  const navigate = useNavigate();

  const { data: dattoAuthConfig } = useGetDattoAuthConfig();

  const [apiKey, setApiKey] = useState(dattoAuthConfig?.data?.api_key || "");
  const [apiSecretKey, setApiSecretKey] = useState(
    dattoAuthConfig?.data?.api_secret_key || "",
  );
  const [apiUrl, setApiUrl] = useState(dattoAuthConfig?.data?.api_url || "");
  const [isNewIntegration, setIsNewIntegration] = useState(false);

  const chooseBoardRef = useRef<{ onSubmit: () => Promise<boolean> }>(null);

  const isPrimaryButtonDisabled = dattoAuthConfig?.data?.is_connected !== true;

  useEffect(() => {
    setApiKey(dattoAuthConfig?.data?.api_key || "");
    setApiSecretKey(dattoAuthConfig?.data?.api_secret_key || "");
    setApiUrl(dattoAuthConfig?.data?.api_url || "");
  }, [dattoAuthConfig]);

  const handleClose = () => {
    onClose();
    setApiKey("");
    setApiSecretKey("");
    setApiUrl("");
  };

  return (
    <Drawer
      title="Connect Datto RMM"
      onClose={handleClose}
      onOpen={onOpen}
      open={open}
      drawerStyle={{
        width: "514px",
      }}
      primaryButtonText={"Proceed"}
      secondaryButtonText="Cancel"
      isPrimaryButtonDisabled={isPrimaryButtonDisabled}
      onSecondaryButtonClick={handleClose}
      onPrimaryButtonClick={async () => {
        if (!isPrimaryButtonDisabled) {
          await chooseBoardRef.current?.onSubmit();
          navigate("datto", {
            state: { isNewIntegration: isNewIntegration },
          });
        }
      }}
    >
      <ConnectDattoAccount
        apiKey={apiKey}
        setApiKey={setApiKey}
        apiSecretKey={apiSecretKey}
        setApiSecretKey={setApiSecretKey}
        apiUrl={apiUrl}
        setApiUrl={setApiUrl}
        chooseBoardRef={chooseBoardRef}
        onWebhookGenerated={() => setIsNewIntegration(true)}
      />
    </Drawer>
  );
};
